module.exports = "<layout-header></layout-header>\r\n<router-outlet>\r\n    <button (click)=\"topFunction()\" id=\"myBtn\" title=\"Go to top\">Go to Top<i class=\"fas fa-long-arrow-alt-up icon\"></i></button>\r\n</router-outlet>\r\n<layout-footer></layout-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main